




















































































































































import { Component, Prop, Vue, PropSync } from 'vue-property-decorator';
import { TransceiversApi, Transceiver, SensorsApi } from '../../api';
import TitleMixin from '@/mixins/title-mixin';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Toast from '@/components/display/toast.vue';

Vue.use(VueVirtualScroller);

@Component({
	components: {},
	mixins: [TitleMixin],
})
export default class RawData extends Vue {
	public currentPage = 1;
	public perPage = 100;
	public totalRows = 0;
	public filter = '';
	public rawData = [];
	public sortKey = '';
	public key = '';
	public active = '';

	@Prop(Number) public transceiverId?: number;
	@PropSync('checkInTime') public localCheckInTime!: string;
	public transceiver: any | null = null;
	public sensors: any[] | null = [];

	public loading = true;
	public rawDataFields: any[] | null = [
		{ key: 'timestamp', label: 'Time Stamp', sortable: true },
		{ key: 'data', label: 'Data' },
		{ key: 'sortKey', label: 'Sort Key' },
	];
	public quickFilterList = ['NSS', 'SVL', 'BEM', 'BleCap', 'DBG:BLE'];
	public form = { filter: '' };
	private api: TransceiversApi;

	public async load() {
		this.loading = true;
		try {
			const { data } = await new TransceiversApi().getTransceiverById(
				parseInt(this.transceiverId, 10),
				{
					params: {
						include: 'sensors,', // sensors
					},
				},
			);
			this.transceiver = data;
			this.sensors = data.sensors || {};
			this.reload();
		} catch (e) {
			console.log(e);
			this.transceiver = null;
		} finally {
			this.loading = false;
		}
	}

	public async reload(key: string, sortKey: string, prev = false) {
		const transceiverId = this.transceiverId;
		try {
			const api = new TransceiversApi();
			const response = await api.getTransceiverRawData(
				parseInt(transceiverId, 10),
				1000,
				this.sortKey,
				this.key,
			);
			response.data.forEach(item => {
				if (1400000000000 > item.timestamp) {
					item.timestamp *= 1000;
				}
			});
			this.rawData = this.rawData.concat(response.data);
			// this.localCheckInTime = this.localCheckInTime === null || this.rawData[0].date.isAfter(this.localCheckInTime) ? this.rawData[0].date : this.localCheckInTime;
			this.sortKey = this.rawData[this.rawData.length - 1].sortKey;
			this.key = this.rawData[this.rawData.length - 1].key;
			this.totalRows = this.rawData.length;
		} catch (e) {
			this.rawData = [];
			this.sortKey = '';
			this.key = '';
			this.totalRows = 0;
			console.log(e);
		}
	}
	public async deallocateSensor(sensor: Sensor) {
		try {
			const api = new SensorsApi();
			const response = await api.deallocateSensor(sensor.id);
		} catch (e) {
			console.log(e);
			new Toast().makeToast(
				`Sensor ${sensor.serialNumber} was not able to be deallocated`,
				'Sensor Not Deallocated',
				'Danger',
				false,
			);
		}
		this.load();
		new Toast().makeToast(
			`Successfully Deallocated Sensor ${sensor.serialNumber}`,
			'Sensor Successfully Deallocated',
			'success',
			false,
		);
	}

	public onFiltered(filteredItems) {
		// Trigger pagination to update the number of buttons/pages due to filtering
		this.totalRows = filteredItems.length;
	}

	public created() {
		this.load();
	}
}
